// @ts-nocheck
import * as React from "react";

const Import: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                d="M12.901 1.757a1.133 1.133 0 1 1 .003 2.264l-8.89.001v15.964h15.959v-8.971c-.003-.26.083-.511.241-.714l.085-.097a1.132 1.132 0 0 1 1.938.807v10.107a1.132 1.132 0 0 1-1.132 1.132H2.885a1.132 1.132 0 0 1-1.133-1.027V2.889a1.132 1.132 0 0 1 1.131-1.132h10.018Zm8.17-.006a1.133 1.133 0 0 1 1.149.87l.024.141c.036.347-.09.69-.338.928l-6.883 6.887h2.256c.259-.005.51.079.714.235l.097.084a1.131 1.131 0 0 1-.806 1.945h-4.997a1.13 1.13 0 0 1-1.131-1.132V6.715a1.134 1.134 0 0 1 1.131-1.148A1.133 1.133 0 0 1 13.42 6.71v2.272l6.892-6.894c.167-.17.384-.283.618-.323l.142-.015Z"
                fill="currentColor"
                fillRule="evenodd"
            />
        </svg>
    );
};

export default React.memo(Import);
